<template>
  <div v-if="services.length > 0" style="margin-top: -10px !important;">
    <div v-for="(service, index) in services" :key="index">
      <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2">
        <div class="text-vertical-center" :title="service.typeService.name">
            {{service.amount}} -
            <template v-if="service.underAgeClient">
                <a class="cursor-pointer" :href="`#/client/${service.underAgeClient.id}/details`">{{service.underAgeClient.name}}</a>
            </template>
            <template v-else>
                {{service.typeService.name}}
            </template>
        </div>
        <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
          {{$n(service.price, 'currency')}}
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="editService(service, index)"><i class="p-ml-2 pi pi-pencil small" :title="$t('protocol.tab-services.edit-service')"/></a>
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="removeService(service, index)"><i class="p-ml-2 pi pi-times small" :title="$t('protocol.tab-services.remove-service')"/></a>
        </div>
      </div>
    </div>
    <div>
      <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2">
        <div class="text-vertical-center">
          <label class="text-center text-vertical-center">{{ $t('forms.add-service.total') }}</label>
        </div>
        <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
          {{$n(totalPrice, 'currency')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/commons/EventBus";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import CardFormService from "@/viewer/protocol/tabs/services/CardFormService";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import store from "@/store";
import {LIMITED} from "@/constants/TypeUser";

export default {
  name: "DisplayServiceClient",

  props:{
    protocolClient: {type: Object, default: () => {}},
    protocol: {type: Object, default: () => {}},
    pricePerClient: {type: Number, default: 0.0},
  },

  beforeMount() {
    EventBus.$on('UPDATE_SERVICE_CLIENT_LIST', this.updateClientList);
  },

  beforeDestroy(){
    EventBus.$off('UPDATE_SERVICE_CLIENT_LIST');
  },

  data(){
    return {
      services: [],
      totalPrice: 0.0,
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
    }
  },

  async mounted() {
    await this.getServicesOfClient();
    this.updateTotalPrice();
  },

  methods:{

    async removeService(service, index){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.deleteTypeOfServiceProtocol(this.protocol.id, service.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.services.splice(index, 1);
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    async getServicesOfClient(){
      const servicesProtocol = await ProtocolBusiness.getServicesOfClient(this.protocol.id, this.protocolClient.client.id);
      this.services.push(...servicesProtocol);
    },

    addService(){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormService,
        paramComponent: {client: this.protocolClient.client},
        callBack: (response) => {
          this.services.push(response);
        },
      });
    },

    editService(service, index){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormService,
        paramComponent: service,
        callBack: (response) => {
          this.$set(this.services, index, response);
          this.addService();
        },
      });
    },

    updateClientList(data = {protocolClient: {}, response: {}}){
      if(this.protocolClient.id === data.protocolClient.id){
        this.services.push(data.response);
        this.updateTotalPrice();
      }
    },

    updateTotalPrice(){
      let price = 0.0;
      this.services.forEach(service => {
        price += service.price;
      });
      this.totalPrice = this.pricePerClient + price;
    },

  }

}
</script>

<style scoped>

  .line-of-service {
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
  }

</style>